import React from 'react';

const SectionTitle = ({title}) => {
  return (
    <h4 className={"section-title"}>{title}</h4>
  );
};

export default SectionTitle;